import { roundDown } from '@/shared/utils/format/roundDown';
import { formatToFirstNonZero } from '@/shared/utils/format/formatToFirstNonZero';

export const addNumberSuffix = (value: number, suffix: string, precision: number = 0) => {
  if (value < 1) {
    return formatToFirstNonZero(value, precision) + suffix;
  }
  if (value > 100) {
    return roundDown(value, 0) + suffix;
  }
  return roundDown(value, 1) + suffix;
};
